import React from "react"

import { Grid, Container, Box, Typography, List, ListItem } from "@mui/material"
import { SimpleUploadFile } from "./components/SimpleUploadFile"
import { PageTabs } from "components/navigation/PageTabs/PageTabs"
import { allRoutes } from "generated/routes"
import PaperBox from "components/PaperBox"
import ImportResult from "./components/ImportResult"
import { useTranslation } from "react-i18next"

const ImportUsers = ({ match }) => {
  const [importResult, setImportResult] = React.useState()
  const { t } = useTranslation()
  return (
    <div>
      <PageTabs
        routeBack
        tabs={[
          {
            path: allRoutes.SystemadminCustomersEditUsers(match.params.id),
            title: t("global.back", "Back")
          }
        ]}
      />
      <Container>
        <Box marginY={3}>
          <Grid item container direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="h2">{t("settings.customer.import_user", "Import users")}</Typography>
          </Grid>
        </Box>
        <PaperBox>
          <Box mb={2}>
            <Typography>
              {t(
                "settings.customer.import_data_by_uploading_a_file",
                "Import data by uploading a file in CSV format. Separators should be semicolons (;) and fields with list values ​​should be separated by commas (,)"
              )}
            </Typography>
            <Box mb={2}></Box>
            <Typography>
              {t(
                "settings.customer.file_must_not_use_column_headings",
                "Filen får inte använda rubriker på kolumnerna utan endast innehålla data"
              )}
            </Typography>
            <Box mb={2}></Box>
            <Typography>
              {t(
                "settings.customer.the_format_of_each_row_must_include",
                "The format of each row must include the following columns"
              )}
              :
            </Typography>
            <List>

              <ListItem>
                {t(
                  "settings.customer.name_required_the_users_full_name",
                  "Namn - Obligatoriskt, användarens fullständiga namn"
                )}
              </ListItem>
              <ListItem>
                {t(
                  "settings.customer.username_required_must_be_unique",
                  "Username - Required, must be unique"
                )}
              </ListItem>
              <ListItem>
                {t(
                  "settings.customer.email_required_if_send_login",
                  "Email - Required if SendLoginData=Yes, must be unique"
                )}
              </ListItem>
              <ListItem>{t("settings.customer.send_login_details", "SendLogin details - Yes/No")}</ListItem>
              <ListItem>
                {t(
                  "settings.customer.companies_list_of_company_names",
                  "Companies - List of company names, the companies must be entered in the customer"
                )}
              </ListItem>
              <ListItem>
                {t(
                  "settings.customer.departments_list_of_department_names",
                  "Departments - List of department names, Departments must be entered on the customer"
                )}
              </ListItem>
              <ListItem>
                {t(
                  "settings.customer.licenses_name_of_licenses",
                  "Licenses - Name of licenses, Associated module must be activated on customer and have enough licenses left. Accepted words: Customer Settings, News, Education, SystemAdminCustomers, SystemAdminUnitRegister, SystemAdminEvents"
                )}
              </ListItem>
              <ListItem>
                {t(
                  "settings.customer.roles_extended_permissions",
                  "Roles - Extended permissions, Associated module must be activated on the customer and also be included in the license list. Accepted words: Education administrator, News administrator"
                )}
              </ListItem>
              <ListItem>
                {t(
                  "settings.customer.learning_list_of_learning_names",
                  "Trainings - List of learning names. The learning module must be activated on the customer, and the training license must also be included in the license list"
                )}
              </ListItem>
              <ListItem>
                {t(
                  "settings.customer.manager_the_username_of_the_user",
                  "Manager - The username of the user to be set as immediate manager"
                )}
              </ListItem>
              <ListItem>
                {t("settings.customer.is_manager", "Is Manager - The user the manager of other users")}
              </ListItem>
              <ListItem>
                {t("settings.customer.social_security_number", "Social security number - Not required")}
              </ListItem>
              <ListItem>
                {t("settings.customer.street_address", "Street address - Not required")}
              </ListItem>
              <ListItem>
                {t("settings.customer.portal_code", "Postal code - Not required")}
              </ListItem>
              <ListItem>
                {t("settings.customer.city", "City - Not required")}
              </ListItem>
              <ListItem>
                {t("settings.customer.phone_number", "Phone number - Not required")}
              </ListItem>
              <ListItem>
                {t("settings.customer.role_template_import", "Role templates - Not required")}
              </ListItem>
            </List>

            <Box mb={2}></Box>
            <Typography>
              {t(
                "settings.customer.if_any_row_has_validation_errors",
                "If any row has validation errors, no rows will be imported. In that case, correct the missing row and upload the file again"
              )}
            </Typography>
            <Box mb={2}></Box>
          </Box>
          <SimpleUploadFile setImportResult={setImportResult} />
          {importResult && <ImportResult items={importResult} />}
        </PaperBox>
      </Container>
    </div>
  )
}
export default ImportUsers
